// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Caml_splice_call from "rescript/lib/es6/caml_splice_call.js";
import * as CommonUtils$OrcaPaymentPage from "../utils/CommonUtils.bs.js";
import * as SuperpositionJs from "./../superposition/superposition.js";
import * as SuperpositionHelper$OrcaPaymentPage from "../utils/SuperpositionHelper.bs.js";

function cacReader(prim) {
  return new SuperpositionJs.CacReader(prim);
}

function useConfigurationService(rawConfigs) {
  var service = React.useMemo((function () {
          if (rawConfigs !== undefined) {
            return Caml_option.nullable_to_opt(new SuperpositionJs.CacReader(rawConfigs));
          }
          
        }), [rawConfigs]);
  return React.useCallback((function (eligibleConnectors, configParams, intentData, isUseBillingAddressOpt, suppressBillingPrefillOpt) {
                var isUseBillingAddress = isUseBillingAddressOpt !== undefined ? isUseBillingAddressOpt : false;
                var suppressBillingPrefill = suppressBillingPrefillOpt !== undefined ? suppressBillingPrefillOpt : false;
                var intentDataDict = CommonUtils$OrcaPaymentPage.getDictFromJson(intentData);
                var match = eligibleConnectors.length === 0;
                var requiredFieldsFromSuperPosition = service !== undefined ? (
                    match ? [] : SuperpositionHelper$OrcaPaymentPage.sortFieldsByPriorityOrder(SuperpositionHelper$OrcaPaymentPage.removeDuplicateFields(Core__Array.reduce(SuperpositionHelper$OrcaPaymentPage.removeDuplicateConnectors(eligibleConnectors), [], (function (acc, connector) {
                                      try {
                                        var connector$1 = Core__JSON.Decode.string(connector);
                                        if (connector$1 !== undefined && connector$1 !== "") {
                                          var transformedContext_payment_method = CommonUtils$OrcaPaymentPage.snakeToPascalCase(configParams.payment_method);
                                          var transformedContext_payment_method_type = CommonUtils$OrcaPaymentPage.snakeToPascalCase(configParams.payment_method_type);
                                          var transformedContext_platform = configParams.platform;
                                          var transformedContext_country = configParams.country;
                                          var transformedContext_mandate_type = configParams.mandate_type;
                                          var transformedContext_always_collect_shipping_details_from_wallet_connector = configParams.always_collect_shipping_details_from_wallet_connector;
                                          var transformedContext_always_collect_billing_details_from_wallet_connector = configParams.always_collect_billing_details_from_wallet_connector;
                                          var transformedContext_currency = configParams.currency;
                                          var transformedContext_profile_id = configParams.profile_id;
                                          var transformedContext_processor_merchant_id = configParams.processor_merchant_id;
                                          var transformedContext_provider_merchant_id = configParams.provider_merchant_id;
                                          var transformedContext_organization_id = configParams.organization_id;
                                          var transformedContext = {
                                            payment_method: transformedContext_payment_method,
                                            payment_method_type: transformedContext_payment_method_type,
                                            platform: transformedContext_platform,
                                            country: transformedContext_country,
                                            mandate_type: transformedContext_mandate_type,
                                            always_collect_shipping_details_from_wallet_connector: transformedContext_always_collect_shipping_details_from_wallet_connector,
                                            always_collect_billing_details_from_wallet_connector: transformedContext_always_collect_billing_details_from_wallet_connector,
                                            currency: transformedContext_currency,
                                            profile_id: transformedContext_profile_id,
                                            processor_merchant_id: transformedContext_processor_merchant_id,
                                            provider_merchant_id: transformedContext_provider_merchant_id,
                                            organization_id: transformedContext_organization_id,
                                            connector: connector$1
                                          };
                                          var resolvedConfig = SuperpositionHelper$OrcaPaymentPage.convertConfigurationToRequiredFields(service.evaluateConfig(transformedContext), isUseBillingAddress);
                                          Caml_splice_call.spliceObjApply(acc, "push", [resolvedConfig]);
                                        }
                                        
                                      }
                                      catch (exn){
                                        
                                      }
                                      return acc;
                                    }))))
                  ) : (
                    match ? [] : []
                  );
                var missingRequiredFields = SuperpositionHelper$OrcaPaymentPage.filterFieldsBasedOnMissingData(requiredFieldsFromSuperPosition, intentDataDict, isUseBillingAddress);
                var initialValues = SuperpositionHelper$OrcaPaymentPage.convertFlatDictToNestedObject(SuperpositionHelper$OrcaPaymentPage.buildInitialValuesFromIntentData(requiredFieldsFromSuperPosition, intentDataDict, suppressBillingPrefill));
                return [
                        requiredFieldsFromSuperPosition,
                        missingRequiredFields,
                        initialValues
                      ];
              }), [service]);
}

export {
  cacReader ,
  useConfigurationService ,
}
/* react Not a pure module */
